var _a;
import { createActions, createAction } from 'redux-actions';
export var getAssistant = (_a = createActions('GET_ASSISTANT', 'GET_ASSISTANT_COMPLETE', 'GET_ASSISTANTS'), _a.getAssistant), getAssistantComplete = _a.getAssistantComplete, getAssistants = _a.getAssistants;
export var getAssistantsComplete = createAction('GET_ASSISTANTS_COMPLETE', function (payload) { return payload; }, function (payload, headers) { return ({
    headers: headers,
}); });
